import { XgacFilter } from './types';

export const GET_ASSETS_DEFAULT_XGAC_FILTER: XgacFilter = {
  request: {
    'embeddedTimestamp:younger': '345600000',
  },
  result: {
    available: '==true',
    distance: '<750',
    assetId: '!=%alarmAssetId%',
  },
};
